<template>
  <div>
    <align class="header" flex>
      <align>
        <h3 class="secondary-font">
          {{ indexId && index ? index.label : 'Index Snapshot' }}
        </h3>

        <pill-dropdown
          v-if="!indexId"
          v-model="activeIndexId"
          :options="indexOptions"
        />
      </align>

      <icon-link @click.native="viewIndex">
        View More
      </icon-link>
    </align>

    <div v-if="index" class="grid">
      <stat-item
        size="xlarge"
        success
        label="Index Value"
        :value="$filters.number(index.dailyIndex)"
      />

      <stat-item
        size="xlarge"
        :success="index.dailyPercentChange > 0"
        :error="index.dailyPercentChange < 0"
        label="Daily Change"
        :value="`${index.dailyPercentChange > 0 ? '+' : ''}${$filters.percentage(index.dailyPercentChange)}`"
      />

      <stat-item
        size="xlarge"
        :success="index.monthlyPercentChange > 0"
        :error="index.monthlyPercentChange < 0"
        label="Monthly Change"
        :value="`${index.monthlyPercentChange > 0 ? '+' : ''}${$filters.percentage(index.monthlyPercentChange)}`"
      />

      <stat-item
        size="xlarge"
        :success="index.quarterlyPercentChange > 0"
        :error="index.quarterlyPercentChange < 0"
        label="Quarterly Change"
        :value="`${index.quarterlyPercentChange > 0 ? '+' : ''}${$filters.percentage(index.quarterlyPercentChange)}`"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import * as Sentry from '@sentry/vue';

import { authService, indexService } from '@/services';

import StatItem from '@cardladder/shared/components/StatItem';

export default {
  components: {
    StatItem,
  },

  props: {
    indexId: String,
  },

  data() {
    return {
      index: null,
    };
  },

  watch: {
    activeIndexId: {
      handler() {
        this.load();
      },
      immediate: true,
    },
  },

  computed: {
    ...mapState({
      user: (state) => state.user,
      indexSnapshot: (state) => state.indexSnapshot,
    }),

    widgetConfig() {
      return this.user.dashboardWidgets.find(({ component }) => component === 'IndexWidget');
    },

    indexOptions() {
      const options = [];

      Object.keys(this.indexSnapshot).forEach((key) => {
        const index = this.indexSnapshot[key];

        options.push({
          label: index.label,
          icon: index.icon,
          value: key,
        });
      });

      return options;
    },

    activeIndexId: {
      get() {
        return this.indexId || this.widgetConfig.activeIndexId || 'cl50index';
      },

      async set(activeIndexId) {
        await authService.updateUser(this.user.uid, {
          dashboardWidgets: [
            ...this.user.dashboardWidgets.map((item) => {
              if (item.component === 'IndexWidget') {
                return {
                  ...item,
                  activeIndexId,
                };
              }

              return item;
            }),
          ],
        });
      },
    },
  },

  methods: {
    async load() {
      try {
        this.index = await indexService.getIndex('indexes', this.activeIndexId);
      } catch (e) {
        Sentry.captureException(e);
      }
    },

    viewIndex() {
      this.$router.push(`/indexes/${this.activeIndexId}`);
    },
  },
};
</script>

<style lang="scss" scoped>
.grid {
  display: grid;
  grid-gap: $gp;
  grid-template-columns: repeat(4, 1fr);

  @media($large-down) {
    grid-template-columns: repeat(2, 1fr);
  }
}

.header {
  margin: 0 0 $gp;
}

h3 {
  margin: 0;
}
</style>
